import * as React from 'react'

const AgileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={36}
    height={36}
    viewBox="0 0 36 36"
  >
    <defs>
      <filter
        id="prefix_agile_b"
        width="106.3%"
        height="103.6%"
        x="-3.2%"
        y="-1.8%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation={0.5}
        />
        <feOffset in="shadowBlurInner1" result="shadowOffsetInner1"/>
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2={-1}
          k3={1}
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.129971591 0"
        />
      </filter>
      <path
        id="prefix_agile_a"
        d="M20.353 3.51c2.51.366 3.435 2.735 2.6 5.326l-.033.098.194.037.243.057c1.7.442 2.55 2.42 2.211 4.197l-.025.116.108.07c1.4.99 1.753 3.236.789 4.746l-.108.16a5.602 5.602 0 01-.487.574l-.204.201.024.015c1.385.912 1.98 2.25 1.288 3.622l-.09.165c-.087.15-.19.299-.307.444l-.045.051.044.064a3.7 3.7 0 01.49 1.191l.04.198c.282 1.551-.367 3.086-1.556 3.92l-.034.022.256.144c.297.17.595.351.896.541l.3.194a1 1 0 01-1.094 1.674 23.396 23.396 0 00-2.037-1.197l-.475-.238-.013.007c-2.272 1.043-4.2 1.536-5.704 1.508l-.234-.009c-1.957-.11-3.244-1.31-2.675-2.835.238-.636.69-1.123 1.316-1.453l.04-.021-.066.004c-1.244.04-1.963-.215-2.273-.845l-.045-.103c-.467-1.175.642-2.068 2.647-2.946l.46-.195.24-.098-.163.028c-.927.153-1.794.217-2.533.175l-.242-.018c-1.084-.1-1.397-1.408-.778-2.123.391-.45.83-.852 1.306-1.205l.159-.115-.137.01c-.781.035-1.41-.063-1.855-.33l-.128-.086c-1.217-.902-.615-2.039.928-3.173l.23-.165-.266.057-.395.073c-1.428.248-2.073-1.534-1.282-2.523 1.895-2.367 5.618-4.273 8.8-4.628l.107-.01.058-.12c.782-1.727.438-3.006-.654-3.25l-.124-.023a1 1 0 01.171-1.99l.117.01zm-1.565 25.112c-1.129-.025-1.888.26-2.13.54l-.029.037c.133.088.366.164.699.199l.175.014c.706.04 1.596-.093 2.647-.413l.402-.129-.188-.045a8.32 8.32 0 00-1.328-.192l-.248-.01zm6.163-3.88l-.044-.07-.046.028c-1.18.678-2.8 1.277-4.868 1.8l-.716.146.232.025c1.1.129 2.33.452 3.638.98l.141.059.598-.308.348-.186c.644-.352 1.036-1.173.883-2.017a1.393 1.393 0 00-.166-.458zm-2.718-.987l-.19.007c-1.186.053-2.615.374-4.113.952l-.376.15-.203.084.073-.01c.313-.045.652-.102 1.017-.169l.763-.147.337-.07c.882-.223 1.65-.445 2.312-.666l.38-.131zm1.636-3.343l-.105.065c-.82.486-1.743.925-2.704 1.3l-.155.059.172-.024c1.503-.201 2.855-.108 3.9.343l.052.023.02-.027c.38-.56.085-1.075-.726-1.52l-.104-.055a5.44 5.44 0 00-.23-.112l-.12-.052zm-3.442-.538l.1-.041-.028.002c-1.349.049-2.727.395-3.901 1.043l-.2.115.255-.04c1.197-.21 2.528-.59 3.774-1.079zm4.175-4.737l-.08.094c-.8.902-1.898 1.715-3.147 2.394l-.39.204.076.001c.782.017 1.55.118 2.277.3l.265.07.085-.06c.356-.27.66-.548.894-.83l.132-.17c.414-.569.323-1.526-.08-1.972l-.032-.031zm-2.32-.688c-1.874.027-4.211 1.121-7.26 3.066l-.187.13.078-.006c.217-.023.46-.055.72-.1l.198-.036c2.422-.464 4.997-1.607 6.583-2.995l.064-.058h-.195zm-3.363-3.14l-.277.093c-1.448.495-2.9 1.276-4.027 2.2l-.082.068.034-.009c1.666-.503 3.079-1.267 4.178-2.198l.174-.154zm3.051-.473l-.027.042a10.06 10.06 0 01-1.41 1.664l-.122.112.023-.005c1.024-.256 1.974-.32 2.883-.168l.322.064.004-.048c.016-.666-.265-1.315-.694-1.5l-.095-.033a4.144 4.144 0 00-.676-.114l-.208-.014z"
      />
    </defs>
    <g
      transform="scale(-1 1) rotate(-20 0 127.91)"
      fill="none"
      fillRule="evenodd"
    >
      <use fill="#E8E9EB" xlinkHref="#prefix_agile_a"/>
      <use fill="#000" filter="url(#prefix_agile_b)" xlinkHref="#prefix_agile_a"/>
    </g>
  </svg>
)

export default AgileIcon
